import React, { useEffect, useState } from 'react';
import { useThrottle } from '@wix/da-hooks/pkg/useThrottle';
import { SCROLL_THROTTLE_TIMEOUT } from '../constants';
/** Calculate overflow tyoe */ export function useSliderOverflow(contentRef) {
    const [overflow, setOverflow] = useState('');
    const updateOverflow = useThrottle(()=>{
        let newOverflow = '';
        if (!contentRef.current) {
            return newOverflow;
        }
        const contentRect = contentRef.current.getBoundingClientRect();
        const scrollLeft = contentRef.current.scrollLeft;
        const scrollWidth = contentRef.current.scrollWidth;
        const scrollRight = scrollWidth - scrollLeft - contentRect.width;
        if (scrollLeft && scrollRight) {
            newOverflow = 'both';
        } else if (scrollLeft) {
            newOverflow = 'left';
        } else if (scrollRight) {
            newOverflow = 'right';
        }
        setOverflow(newOverflow);
    }, [], SCROLL_THROTTLE_TIMEOUT, {
        leading: true
    });
    useEffect(()=>{
        const contentNode = contentRef.current;
        updateOverflow();
        window.addEventListener('resize', updateOverflow);
        contentNode === null || contentNode === void 0 ? void 0 : contentNode.addEventListener('scroll', updateOverflow);
        return ()=>{
            window.removeEventListener('resize', updateOverflow);
            contentNode === null || contentNode === void 0 ? void 0 : contentNode.removeEventListener('scroll', updateOverflow);
        };
    }, [
        updateOverflow,
        contentRef
    ]);
    return overflow;
}
